import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SelectUser.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";

const SelectUser = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      const querySnapshot = await getDocs(collection(db, "users"));
      const fetchedUsers = querySnapshot.docs.map(doc => ({
        id: doc.id,           // 🔑 зберігаємо id для унікального ключа
        ...doc.data()
      }));

      // 🔡 Сортуємо дітей та батьків окремо
      const children = fetchedUsers
        .filter(user => user.type === "child")
        .sort((a, b) => a.name.localeCompare(b.name, "uk"));

      const parents = fetchedUsers
        .filter(user => user.type !== "child")
        .sort((a, b) => a.name.localeCompare(b.name, "uk"));

      setUsers([...children, ...parents]);
    };

    fetchUsers();
  }, []);

  const handleSelect = (user) => {
    localStorage.setItem("selectedUser", JSON.stringify(user));
    navigate("/login");
  };

  return (
    <div className="select-user">
      <h2>Вибери свій профіль</h2>
      <div className="tabs">
        {users.map((user) => (
          <div
            key={user.id} // 🔐 унікальний і стабільний ключ
            className="user-tab"
            style={{ backgroundColor: user.color }}
            onClick={() => handleSelect(user)}
          >
            <img src={user.photo} alt={user.name} className="avatar" />
            <h4>{user.name}</h4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectUser;
